import React from "react";
import { twMerge } from "tailwind-merge";

import HeroContent from "./HeroContent";
import HeroOverlay from "./HeroOverlay";

export type HeroProps = React.HTMLAttributes<HTMLDivElement>;

const Hero: React.FC<HeroProps> = ({ className, children, ...props }) => {
  const classes = twMerge("hero", className);

  return (
    <div role="banner" {...props} className={classes}>
      {children}
    </div>
  );
};

export default Object.assign(Hero, {
  Content: HeroContent,
  Overlay: HeroOverlay,
});
